<ng-container *ngIf="searchable; else modalSelect">
  <div class="search-field">
    <ion-input
      #searchInputEl
      [formControl]="searchControl"
      [placeholder]="placeholder ?? '' | translate"
      (ionFocus)="onSearchFocus()"
      (ionBlur)="onSearchBlur()"
      data-cy="Budget item search"
      class="text-grey-ultra-dark font-normal ion-no-padding ion-no-margin"
    ></ion-input>

    <!-- Moved to document.body (see ngAfterViewInit) so no ancestor overflow/stacking context can clip or cover it. -->
    <div #dropdownEl class="search-dropdown" [ngStyle]="dropdownStyle">
      <ion-list *ngIf="showResults && searchResults.length > 0" class="search-results" data-cy="Budget item search results">
        <ion-item
          *ngFor="let result of searchResults"
          [button]="true"
          (mousedown)="onResultSelected(result)"
          data-cy="Budget item search result"
        >
          <ion-label>
            <h2 class="font-medium">
              <ng-container *ngIf="project?.showBudgetItemCodesInStp && result.budgetItem.code"
                >{{ result.budgetItem.code }} - </ng-container
              >{{ result.budgetItem.name }}
            </h2>
            <p>{{ result.macroItem.name }}</p>
          </ion-label>
        </ion-item>
      </ion-list>

      <ion-list *ngIf="showResults && (searchControl.value ?? '').length > 0 && searchResults.length === 0" class="search-results">
        <ion-item lines="none">
          <ion-label class="text-grey-medium">{{ 'pages.insert.form.subtaskModal.noResults' | translate }}</ion-label>
        </ion-item>
      </ion-list>
    </div>
  </div>
</ng-container>

<ng-template #modalSelect>
  <ion-input
    [placeholder]="placeholder ?? '' | translate"
    [readonly]="true"
    [value]="displayText"
    (click)="openModal()"
    data-cy="Budget item select"
    class="text-grey-ultra-dark font-normal ion-no-padding ion-no-margin"
  ></ion-input>
</ng-template>
